export var createMuiAutocompleteOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        inputRoot: {
            '&[class*="MuiOutlinedInput-root"]': {
                minHeight: spacing(12),
                // Regular without label
                padding: spacing(0),
                "& $input": {
                    padding: spacing(4),
                },
                "& $input:first-child": {
                    paddingLeft: spacing(4),
                    paddingRight: 0,
                },
                // Regular with label
                "label + &": {
                    padding: spacing(6, 4, 2),
                },
                "label + & $input:first-child": {
                    paddingLeft: 0,
                },
                "label + & $input": {
                    padding: spacing(0, 0, 0),
                    height: spacing(4),
                },
                "label + & $tag": {
                    margin: spacing(0.5, 1, 0.5, 0),
                    maxWidth: "100%",
                },
                "label + & $tag + $input": {
                    alignSelf: "center",
                },
                '&[class*="MuiOutlinedInput-marginDense"]': {
                    padding: spacing(2.25, 2, 1.75),
                    minHeight: "auto",
                    "& $input": {
                        padding: 0,
                    },
                },
                '&[class*="MuiInputBase-adornedStart"]': {
                    padding: spacing(5.25, 4, 1.75),
                },
                '&[class*="MuiInputBase-adornedStart"] > $input': {
                    alignSelf: "flex-end",
                },
                '& [class*="MuiAutocomplete-endAdornment"]': {
                    right: spacing(3.6),
                },
            },
            '&[class*="MuiInputBase-adornedStart"] > [class*="MuiInputAdornment-positionStart"]': {
                padding: 0,
                margin: spacing(0, 4, 0, 0),
                alignSelf: "flex-start",
            },
        },
        popupIndicator: {
            color: palette.text.secondary,
        },
        paper: {
            backgroundColor: palette.background.overlays,
            boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35);",
        },
        option: {
            color: palette.text.secondary,
            // Paddings have to be overwritten separately because original styles also define them like this.
            // i.e. padding: spacing(2, 4) won't work
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
            paddingLeft: spacing(4),
            paddingRight: spacing(4),
            // Hover
            '&[data-focus="true"]': {
                color: palette.text.primary,
                backgroundColor: palette.action.hover,
            },
            // Selected
            '&[aria-selected="true"]': {
                color: palette.text.primary,
                backgroundColor: palette.action.selected,
            },
        },
    });
};
//# sourceMappingURL=MuiAutocomplete.js.map